import React from "react";
import "./NailExtensionMaintain.css";
const NailExtensionMaintain = () => {
  return (
    <div className="nailExtensionMaintain">
      <h5>Maintaining Your Nail Extensions</h5>
      <p>
        Proper maintenance is key to keeping your nail extension in Bangalore
        looking flawless. Here are some tips to help you care for your new
        nails:
      </p>
      <ul>
        <li>
          <h6>Avoid Harsh Chemicals</h6>Use gloves when handling cleaning
          products or other harsh chemicals to prevent damage to your
          extensions.
        </li>
        <li>
          <h6>Regular Fills: </h6>Schedule regular fill appointments at SCENT
          Salon to maintain the integrity and appearance of your extensions.
        </li>
        <li>
          <h6>Moisturize: </h6>Keep your cuticles and nails hydrated with
          quality oils and creams to promote overall nail health.
        </li>
      </ul>
    </div>
  );
};

export default NailExtensionMaintain;
